module.exports = __webpack_public_path__ + "static/media/bg-image-35.61579f40.jpg";